export default {
  data: function () {
    return {
      showTopShadow: false,
      showBottomShadow: false
    };
  },
  mounted() {
    const element = this.$refs.container.children[1];
    if (element) {
      this.ShadowsByScroll(element);
      element.addEventListener('scroll', this.OnScroll);
    }
  },
  methods: {
    OnScroll: function (e) {
      this.ShadowsByScroll(e.target);
    },
    ShadowsByScroll: function (element) {
      if (!element) return;
      this.showTopShadow = element.scrollTop !== 0;
      this.showBottomShadow = element.scrollTop + element.clientHeight !== element.scrollHeight;
    }
  }
};